import { useState } from "react";
import EmailTemplatePicker from "../email/EmailTemplatePicker";
import { webUrlNode } from "../../../../constants/appInfo";
import { steps } from "framer-motion";


export default function CreateCanvasStepForm({
  defaultX = 120,
  defaultY = 120,
  onCreated,xCord,yCord
}) {

  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isStart, setIsStart] = useState(false);
  const [x, setX] = useState(defaultX);
  const [y, setY] = useState(defaultY);
  const [saving, setSaving] = useState(false);

  async function createStep() {

    if (!selectedTemplate) {
      alert("Please select an email template");
      return;
    }

    setSaving(true);

    const res = await fetch(`${webUrlNode}/api/funnels/steps`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({appId:35,
        templateId: selectedTemplate.templateId,title:"Step "+(xCord+1),
        useCase: selectedTemplate.useCase,
        x:x+(xCord+1)*50,
        y,
        isStart
      })
    });

    const data = await res.json();
    setSaving(false);

    if (!res.ok) {
      alert(data?.error || "Failed to create step");
      return;
    }

    setSelectedTemplate(null);
    setIsStart(false);

    onCreated && onCreated(data);
  }

  return (
    <div style={{ padding: 12,position:"relative",zIndex:999 }}>

      <h4>Create step {xCord+1}</h4>

      <EmailTemplatePicker
        value={selectedTemplate?.templateId}
        onChange={setSelectedTemplate}
      />

      <div style={{ marginTop: 8 }}>
        <label>X</label>
        <input
          type="number"
          value={x}
          onChange={e => setX(Number(e.target.value))}
          style={{ width: "100%" }}
        />
      </div>

      <div style={{ marginTop: 8 }}>
        <label>Y</label>
        <input
          type="number"
          value={y}
          onChange={e => setY(Number(e.target.value))}
          style={{ width: "100%" }}
        />
      </div>

      <div style={{ marginTop: 8 }}>
        <label>
          <input
            type="checkbox"
            checked={isStart}
            onChange={e => setIsStart(e.target.checked)}
          />
          {" "}Start step
        </label>
      </div>

      {selectedTemplate && (
        <div style={{ marginTop: 8, fontSize: 12, color: "#666" }}>
          useCase: {selectedTemplate.useCase}
        </div>
      )}

      <button
        style={{ marginTop: 10 }}
        onClick={createStep}
        disabled={saving}
      >
        {saving ? "Creating..." : "Create step"}
      </button>

    </div>
  );
}
